var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcPauseT1Outlined20Px = function SvgIcPauseT1Outlined20Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.24 11.297a1.486 1.486 0 0 0 0-2.594L5.245 4.197C4.244 3.632 3 4.35 3 5.494v9.012c0 1.144 1.244 1.862 2.246 1.297l7.993-4.506Zm-.496-1.73a.495.495 0 0 1 0 .865l-7.993 4.506a.501.501 0 0 1-.749-.432V5.494c0-.381.415-.62.749-.433l7.993 4.507ZM17 4.5a.5.5 0 0 0-1 0v11a.5.5 0 0 0 1 0v-11Z",
    clipRule: "evenodd"
  })));
};
export default SvgIcPauseT1Outlined20Px;